import React from "react";

import { Navbar, Toolbar } from "..";

import { useVhListener } from "../../../hooks";
import useStyles from "./styles";
import { Grid } from "@material-ui/core";

const Layout = ({
  children,
  leftContainerChildren,
  centerContainerChildren,
  rightContainerChildren,
  mainClass
}) => {
  const [{ vhUpdated }] = useVhListener();
  const { content } = useStyles({ vhUpdated });

  // TODO: Tengo que obtener el valor del safe area para pasarselo a content y restarlo

  return (
    <main className={mainClass}>
      <Navbar
        leftContainerChildren={leftContainerChildren}
        centerContainerChildren={centerContainerChildren}
        rightContainerChildren={rightContainerChildren}
      />
      <Grid id="content" container className={content}>
        {children}
      </Grid>
      <Toolbar />
    </main>
  );
};

export default Layout;
